import { render, staticRenderFns } from "./TagListView.vue?vue&type=template&id=4769f1fd&"
import script from "./TagListView.vue?vue&type=script&lang=ts&"
export * from "./TagListView.vue?vue&type=script&lang=ts&"
import style0 from "./TagListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports